import React from "react";
import { Modal, Button, Grid, GridRow, GridColumn, List } from "semantic-ui-react";
import { useTranslation } from "react-i18next";
//import LanguageMenu from "components/LanguageMenu/LanguageMenu";

const TermsOfUse = ({ open, onClose }) => {
  const { t } = useTranslation("common");

  return (
    <Modal open={open} onClose={onClose} size="large">
      <Modal.Content
        scrolling
        className="terms-of-use"
        style={{
          display: "flex",
          justifyContent: "center",
          maxHeight: "none",
        }}
      >
        <div className="terms_of_use">
          <Grid className="terms_of_use_container">
            {/*<GridRow className="terms_of_use_language_menu">
              <LanguageMenu />
            </GridRow>*/}
            <GridRow className="terms_of_use_title">{t("termsOfUse.title")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section1.title")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section1.paragraph")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section2.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section2.paragraph1")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section2.paragraph2")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section2.paragraph3")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section2.paragraph4")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section2.paragraph5")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section3.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section3.paragraph1")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section3.paragraph2")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section3.paragraph3")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section3.paragraph4")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section4.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section4.paragraph")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section5.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section5.paragraph1")}</GridRow>
            <List bulleted>
              <List.Item>{t("termsOfUse.section5.paragraph2")}</List.Item>
              <List.Item>{t("termsOfUse.section5.paragraph3")}</List.Item>
            </List>
            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section6.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section6.paragraph1")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section6.paragraph2")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section6.paragraph3")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section7.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section7.paragraph1")}</GridRow>
            <GridRow className="subheader">
              <GridColumn className="subheader_letter">a)</GridColumn>
              <GridColumn className="subheader_paragraph">
                {t("termsOfUse.section7.subheaders.a")}
              </GridColumn>
            </GridRow>
            <GridRow className="subheader">
              <GridColumn className="subheader_letter">b)</GridColumn>
              <GridColumn className="subheader_paragraph">
                {t("termsOfUse.section7.subheaders.b")}
              </GridColumn>
            </GridRow>
            <GridRow className="subheader">
              <GridColumn className="subheader_letter">c)</GridColumn>
              <GridColumn className="subheader_paragraph">
                {t("termsOfUse.section7.subheaders.c")}
              </GridColumn>
            </GridRow>
            <GridRow className="subheader">
              <GridColumn className="subheader_letter">d)</GridColumn>
              <GridColumn className="subheader_paragraph">
                {t("termsOfUse.section7.subheaders.d")}
              </GridColumn>
            </GridRow>
            <GridRow className="subheader">
              <GridColumn className="subheader_letter">e)</GridColumn>
              <GridColumn className="subheader_paragraph">
                {t("termsOfUse.section7.subheaders.e")}
              </GridColumn>
            </GridRow>
            <GridRow className="subheader">
              <GridColumn className="subheader_letter">f)</GridColumn>
              <GridColumn className="subheader_paragraph">
                {t("termsOfUse.section7.subheaders.f")}
              </GridColumn>
            </GridRow>
            <GridRow className="subheader">
              <GridColumn className="subheader_letter">g)</GridColumn>
              <GridColumn className="subheader_paragraph">
                {t("termsOfUse.section7.subheaders.g")}
              </GridColumn>
            </GridRow>
            <GridRow className="subheader">
              <GridColumn className="subheader_letter">h)</GridColumn>
              <GridColumn className="subheader_paragraph">
                {t("termsOfUse.section7.subheaders.h")}
              </GridColumn>
            </GridRow>

            <GridRow className="paragraph">{t("termsOfUse.section7.paragraph2")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section8.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section8.paragraph1")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section8.paragraph2")}</GridRow>
            <List bulleted>
              <List.Item>{t("termsOfUse.section8.paragraph3")}</List.Item>
              <List.Item>{t("termsOfUse.section8.paragraph4")}</List.Item>
              <List.Item>{t("termsOfUse.section8.paragraph5")}</List.Item>
              <List.Item>{t("termsOfUse.section8.paragraph6")}</List.Item>
            </List>
            <GridRow className="paragraph">{t("termsOfUse.section8.paragraph7")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section9.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section9.paragraph1")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section9.paragraph2")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section10.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section10.paragraph1")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section10.paragraph2")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section10.paragraph3")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section11.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section11.paragraph")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section12.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section12.paragraph")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section13.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section13.paragraph1")}</GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section13.paragraph2")}</GridRow>
            <List bulleted>
              <List.Item>{t("termsOfUse.section13.paragraph3")}</List.Item>
              <List.Item>{t("termsOfUse.section13.paragraph4")}</List.Item>
              <List.Item>{t("termsOfUse.section13.paragraph5")}</List.Item>
              <List.Item>{t("termsOfUse.section13.paragraph6")}</List.Item>
            </List>
            <GridRow className="paragraph">{t("termsOfUse.section13.paragraph7")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section14.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section14.paragraph")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section15.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section15.paragraph")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section16.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section16.paragraph")}</GridRow>

            <GridRow className="header">
              <GridColumn className="title">{t("termsOfUse.section17.header")}</GridColumn>
            </GridRow>
            <GridRow className="paragraph">{t("termsOfUse.section17.paragraph")}</GridRow>
          </Grid>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          style={{
            backgroundColor: "#4700a3",
            color: "white",
          }}
          onClick={onClose}
        >
          {t("close")}
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

export default TermsOfUse;
